import { render, staticRenderFns } from "./GridModality.vue?vue&type=template&id=2692d678"
import script from "./GridModality.vue?vue&type=script&lang=js"
export * from "./GridModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2692d678')) {
      api.createRecord('2692d678', component.options)
    } else {
      api.reload('2692d678', component.options)
    }
    module.hot.accept("./GridModality.vue?vue&type=template&id=2692d678", function () {
      api.rerender('2692d678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/GridModality.vue"
export default component.exports